var map = {
	"./en/AccountPayment.json": 1617,
	"./en/AppJSMessage.json": 1618,
	"./en/ContractManagement.json": 1619,
	"./en/ReportTool.json": 1620,
	"./en/ReportUsermanual.json": 1621,
	"./en/Settlements.json": 1622,
	"./en/StockTransfer.json": 1623,
	"./en/SystemMaintenanceApplicationSupport.json": 1624,
	"./en/SystemMaintenanceMasterManagement.json": 1625,
	"./en/SystemMaintenanceSpecialFunctions.json": 1626,
	"./en/WarehouseReceipts.json": 1627,
	"./en/translate.json": 1628,
	"./hi/AppJSMessage.json": 1629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1616;